<script>
export default {
  props: {
    images: {
      type: Array,
      required: true,
      default: [],
    },
    selectedIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      watchingIndex: this.selectedIndex,
      touchStartX: 0,
      touchEndX: 0,
    };
  },
  watch: {
    selectedIndex() {
      this.watchingIndex = this.selectedIndex;
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyboardNavigation);
    document.addEventListener('touchstart', this.handleTouchStart);
    document.addEventListener('touchend', this.handleTouchEnd);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeyboardNavigation);
    document.removeEventListener('touchstart', this.handleTouchStart);
    document.removeEventListener('touchend', this.handleTouchEnd);
  },
  computed: {
    currentImage() {
      return this.images?.[this.watchingIndex]?.orgImageUrl || false;
    },
  },
  methods: {
    next() {
      if (this.watchingIndex < this.images.length - 1) {
        this.watchingIndex++;
      }
    },
    prev() {
      if (this.watchingIndex > 0) {
        this.watchingIndex--;
      }
    },
    close() {
      document.removeEventListener('keydown', this.handleKeyboardNavigation);
      document.removeEventListener('touchstart', this.handleTouchStart);
      document.removeEventListener('touchend', this.handleTouchEnd);
      this.$refs.dialog.close();
    },
    handleTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
    },
    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].screenX;
      this.checkDirection();
    },
    checkDirection() {
      if (this.touchEndX < this.touchStartX) {
        // Go to next image
        this.next();
      }
      if (this.touchEndX > this.touchStartX) {
        // Go to previous image
        this.prev();
      }
    },
    handleKeyboardNavigation(e) {
      // Tracking 'tab' and 'shift + tab' to keep focus within an element,
      if (e.key === 'Tab') {
        const focusable = document
          .querySelector('.dialog-image-modal')
          .querySelectorAll('button,a');
        if (focusable.length) {
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          const shift = e.shiftKey;
          if (shift) {
            if (e.target === first) {
              last.focus();
              e.preventDefault();
            }
          } else if (e.target === last) {
            first.focus();
            e.preventDefault();
          }
        }
      }
    },
  },
};
</script>

<template>
  <dialog ref="dialog" class="dialog-image-modal">
    <button @click="close" class="dialog-image-modal__close">
      <i class="material-icons">close</i>
    </button>

    <div class="dialog-image-wrapper">
      <button
        v-if="watchingIndex > 0"
        @click="prev"
        class="dialog-image-wrapper__prev"
      >
        <i class="material-icons">arrow_back</i>
      </button>
      <!-- IMG -->
      <img v-if="currentImage" :src="currentImage" alt="" />
      <!-- /IMG -->
      <button
        v-if="watchingIndex < images.length - 1"
        @click="next"
        class="dialog-image-wrapper__next"
      >
        <i class="material-icons">arrow_forward</i>
      </button>
    </div>
  </dialog>
</template>
